export const oneFortyEighthPtBr = {
  registeredEffective: 'Opção registrada com início em {{date}}.',
  singleOwnerRequired:
    'Para esta opção, selecione um único ativo agregado com classe de imobilizado definida.',
  initialTitle: 'Revisar crédito de PIS/COFINS em 1/48',
  conversionTitle: 'Alterar apropriação para 1/48',
  description: 'Confira a base fiscal e a distribuição dos créditos antes de registrar a opção.',
  action: 'Revisar opção em 1/48',
  ready: 'Base fiscal conferida. A opção será registrada junto com a decisão de capitalização.',
  success: 'Opção registrada com {{count}} parcelas fiscais.',
  blocked: 'Não é possível confirmar esta opção. Revise a origem e a base fiscal.',
  previewRequired: 'Confira a origem e gere uma prévia válida antes de confirmar.',
  cancel: 'Cancelar',
  close: 'Fechar',
  load: 'Carregar componentes',
  preview: 'Conferir prévia',
  usePreview: 'Usar esta prévia',
  confirm: 'Confirmar alteração',
  competence: 'Competência inicial',
  prospective:
    'A apropriação começa nesta competência. Créditos de meses anteriores não são acumulados aqui.',
  basisTitle: 'Formação da base fiscal',
  basisHint:
    'A evidência desta revisão deve sustentar todos os componentes e tratamentos tributários listados. A base fiscal pode diferir do custo contábil; valores já excluídos não são subtraídos novamente.',
  basisEffect: 'Efeito na base',
  component: 'Componente',
  source: 'Origem',
  amount: 'Valor documental',
  amountState: 'Composição do valor de origem',
  recoverability: 'Recuperabilidade do tributo',
  select: 'Selecione',
  directCode: 'Referência da atribuição ao ativo',
  directDescription: 'Evidência da atribuição direta',
  basisCode: 'Referência da revisão da base',
  basisDescription: 'Evidência da revisão da base',
  reconciliation: 'Conciliação fiscal',
  originalBasis: 'Base fiscal original',
  consumedBasis: 'Base fiscal já apropriada',
  residualBasis: 'Base fiscal residual',
  preservedHistory:
    '{{count}} parcelas passadas preservadas; {{superseded}} parcelas futuras serão substituídas.',
  tax: 'Tributo',
  sourceFace: 'Potencial de origem',
  statutoryFace: 'Crédito pela base fiscal',
  historicalFace: 'Já apropriado',
  futureFace: 'Ainda a apropriar',
  schedule: '{{tax}}: {{count}} parcelas, total {{amount}}',
  quota: 'Parcela',
  fiscalBasis: 'Base fiscal',
  credit: 'Crédito',
  electionTitle: 'Evidência da opção',
  legalScope:
    'Este fluxo registra a opção para apuração. O aperfeiçoamento legal pelo recolhimento é uma etapa externa e não é comprovado por esta confirmação.',
  electionCode: 'Referência da opção',
  electionDescription: 'Evidência da opção',
  result:
    '{{replaced}} parcelas futuras substituídas e {{transfers}} realocações de perda registradas.',
  noJournal:
    'A mudança de método preserva os lançamentos passados e não gera nova despesa ou receita.',
  kinds: {
    ASSET_PRICE: 'Preço do bem',
    UNCONDITIONAL_COMMERCIAL_DISCOUNT: 'Desconto incondicional',
    RETURN_OR_CANCELLATION: 'Devolução ou cancelamento',
    ACQUISITION_FREIGHT: 'Frete de aquisição',
    ACQUISITION_INSURANCE: 'Seguro de aquisição',
    INSTALLATION_OR_ASSEMBLY: 'Instalação ou montagem',
    IPI: 'IPI',
    ACQUISITION_ICMS: 'ICMS da aquisição',
    OTHER_DIRECTLY_ATTRIBUTABLE: 'Outro custo diretamente atribuível',
    OTHER_INDIRECT_TAX: 'Outro tributo indireto',
  },
  states: {
    GROSS_INCLUDES_COMPONENT: 'Valor bruto inclui este componente',
    ALREADY_NET_OF_COMPONENT: 'Valor já líquido deste componente',
  },
  recoverabilityValues: {
    RECOVERABLE: 'Recuperável',
    NON_RECOVERABLE: 'Não recuperável',
    NOT_APPLICABLE: 'Não se aplica',
  },
  errors: {
    FIXED_ASSET_PIS_COFINS_JURISDICTION_UNSUPPORTED:
      'Créditos de PIS/COFINS do imobilizado estão disponíveis somente para entidades brasileiras. Revise a entidade do ativo e a origem fiscal.',
    FIXED_ASSET_1_48_COMMAND_CONFLICT:
      'Esta confirmação já foi registrada com outra evidência. Recarregue o ativo e confira a opção existente.',
    FIXED_ASSET_1_48_LATER_ALLOWANCE_STATE:
      'Há uma revisão de perda posterior à competência escolhida. Escolha uma competência que preserve a sequência do histórico.',
    FIXED_ASSET_1_48_SOURCE_EVIDENCE_INVALID:
      'A origem não possui evidência fiscal íntegra para esta opção. Revise o documento, o item e os créditos de origem.',

    FIXED_ASSET_1_48_CONVERSION_UNSUPPORTED:
      'Este ativo não atende aos requisitos para a mudança de método. Revise a classe, a origem e a opção fiscal já registrada.',
    FIXED_ASSET_1_48_PERIOD_NOT_OPEN:
      'A competência escolhida não está aberta. Revise o período contábil.',
    FIXED_ASSET_1_48_SOURCE_FACE_MISMATCH:
      'A base revisada não concilia com os créditos da origem. Corrija a origem antes de confirmar.',
    FIXED_ASSET_FISCAL_BASIS_COMPONENT_EVIDENCE_REQUIRED:
      'Falta uma nota fiscal recebida com dados completos e vínculo ao item da conta. Revise a origem documental antes de continuar.',
    FIXED_ASSET_FISCAL_BASIS_COMPONENT_IDENTITY_INVALID:
      'Os componentes não correspondem à origem atual. Recarregue os componentes e revise novamente.',
    FIXED_ASSET_FISCAL_BASIS_EXTERNAL_SOURCE_UNSUPPORTED:
      'Custos externos à nota vinculada ainda não podem ser incluídos neste fluxo.',
    FIXED_ASSET_FISCAL_BASIS_REVIEW_IMMUTABLE:
      'Esta base já foi registrada. Uma correção exige nova evidência e preservação do histórico.',
    FIXED_ASSET_FISCAL_BASIS_REVIEW_REQUIRED:
      'Revise os componentes e informe a evidência da base fiscal.',
    FIXED_ASSET_FISCAL_BASIS_SCOPE_UNSUPPORTED:
      'Este fluxo atende máquina ou equipamento novo doméstico, em BRL e de uso direto em receitas não cumulativas. Revise a classificação.',
    FIXED_ASSET_FISCAL_BASIS_SOURCE_LINE_REQUIRED:
      'Vincule a aquisição a um item identificado da conta a pagar.',
    FIXED_ASSET_PIS_COFINS_RECOVERABILITY_REQUIRED:
      'Registre a expectativa de recuperação do crédito e sua evidência antes de continuar.',
    FIXED_ASSET_FISCAL_BASIS_COMPONENT_RELATIONSHIP_INVALID:
      'A composição declarada pode duplicar uma inclusão ou exclusão. Revise o valor bruto e os componentes já líquidos.',
    FIXED_ASSET_FISCAL_BASIS_OWNER_ALLOCATION_INVALID:
      'O componente deve estar integralmente atribuído a este ativo neste fluxo. Revise sua origem.',
    FIXED_ASSET_FISCAL_BASIS_SPECIAL_RULE_UNSUPPORTED:
      'A aquisição usa tratamento especial ainda não disponível neste fluxo.',
    FIXED_ASSET_FISCAL_BASIS_INVALID:
      'A base fiscal não pôde ser validada. Confira os componentes, os valores documentais e suas evidências.',

    FIXED_ASSET_1_48_BASIS_REVIEW_REQUIRED:
      'Revise os componentes e informe a evidência da base fiscal.',
    FIXED_ASSET_FISCAL_BASIS_EVIDENCE_REQUIRED:
      'Falta evidência documental da base fiscal. Revise a origem antes de continuar.',
    FIXED_ASSET_FISCAL_BASIS_COMPONENT_OVERLAP:
      'Há componentes repetidos ou já incluídos no preço. Revise a composição da base.',
    FIXED_ASSET_FISCAL_BASIS_ALLOCATION_UNBALANCED:
      'Os valores atribuídos ao ativo não conciliam com os documentos de origem.',
    FIXED_ASSET_FISCAL_BASIS_TAX_TREATMENT_REQUIRED:
      'Confirme o tratamento fiscal dos tributos da aquisição.',
    FIXED_ASSET_FISCAL_BASIS_SOURCE_NOT_CREDITABLE:
      'A origem não atende às condições de crédito deste método.',
    FIXED_ASSET_FISCAL_BASIS_FACE_MISMATCH:
      'A base fiscal revisada não concilia com o crédito da origem. Corrija a origem antes de confirmar.',
    FIXED_ASSET_IMPORT_BASIS_UNSUPPORTED:
      'A base de importação ainda não está disponível neste fluxo.',
    FIXED_ASSET_1_48_RATE_RULE_UNSUPPORTED:
      'Esta regra de alíquota requer um tratamento ainda não disponível neste fluxo.',
    FIXED_ASSET_1_48_PREVIEW_STALE:
      'A origem ou a apuração mudou. Gere uma nova prévia antes de confirmar.',
    FIXED_ASSET_1_48_PERIOD_CLOSED:
      'A competência escolhida não está aberta. Revise o período contábil.',
    FIXED_ASSET_1_48_FACE_RECONCILIATION_INVALID:
      'O histórico e o saldo futuro não conciliam com o crédito original.',
    FIXED_ASSET_1_48_INSTALLMENT_STATE_INVALID:
      'Existem parcelas pendentes ou incompatíveis com a mudança. Revise o histórico fiscal.',
    FIXED_ASSET_1_48_ALLOWANCE_TRANSFER_INVALID:
      'A perda de recuperabilidade não pode ser realocada com os vínculos atuais.',
    FIXED_ASSET_1_48_HISTORICAL_ELECTION_EVIDENCE_REQUIRED:
      'Esta tela registra uma nova opção a partir do mês atual. Uma opção de competência anterior exige evidência do ato histórico e correção dos períodos, fluxo ainda não disponível aqui.',
    FIXED_ASSET_1_48_EFFECTIVE_PERIOD_UNSUPPORTED:
      'Uma nova opção de PIS/COFINS deve começar até dezembro de 2026. Para competências a partir de 2027, revise o tratamento de transição para CBS.',
    FIXED_ASSET_1_48_INPUT_INVALID: 'Revise a competência e os dados da opção em 1/48.',
  },
};

export const oneFortyEighthEn: typeof oneFortyEighthPtBr = {
  registeredEffective: 'Election recorded with effect from {{date}}.',
  singleOwnerRequired:
    'This election requires one aggregate asset with an assigned fixed-asset class.',
  initialTitle: 'Review PIS/COFINS credit in 48 installments',
  conversionTitle: 'Switch to 48 installments',
  description: 'Review the tax basis and credit schedule before recording the election.',
  action: 'Review 48-installment election',
  ready: 'Tax basis reviewed. The election will be recorded with the capitalization decision.',
  success: 'Election recorded with {{count}} tax installments.',
  blocked: 'This election cannot be confirmed. Review the source and tax basis.',
  previewRequired: 'Review the source and generate a valid preview before confirming.',
  cancel: 'Cancel',
  close: 'Close',
  load: 'Load components',
  preview: 'Review preview',
  usePreview: 'Use this preview',
  confirm: 'Confirm change',
  competence: 'First tax period',
  prospective: 'Credits begin in this period. Earlier periods are not accumulated here.',
  basisTitle: 'Tax basis composition',
  basisHint:
    'This review evidence must support every listed component and tax treatment. Tax basis may differ from accounting cost; already-excluded amounts are not deducted twice.',
  basisEffect: 'Basis effect',
  component: 'Component',
  source: 'Source',
  amount: 'Document amount',
  amountState: 'Source amount composition',
  recoverability: 'Tax recoverability',
  select: 'Select',
  directCode: 'Asset attribution reference',
  directDescription: 'Direct attribution evidence',
  basisCode: 'Basis review reference',
  basisDescription: 'Basis review evidence',
  reconciliation: 'Tax reconciliation',
  originalBasis: 'Original tax basis',
  consumedBasis: 'Tax basis already appropriated',
  residualBasis: 'Residual tax basis',
  preservedHistory:
    '{{count}} past installments preserved; {{superseded}} future installments will be replaced.',
  tax: 'Tax',
  sourceFace: 'Original potential',
  statutoryFace: 'Credit from tax basis',
  historicalFace: 'Already appropriated',
  futureFace: 'Yet to appropriate',
  schedule: '{{tax}}: {{count}} installments, total {{amount}}',
  quota: 'Installment',
  fiscalBasis: 'Tax basis',
  credit: 'Credit',
  electionTitle: 'Election evidence',
  legalScope:
    'This workflow records the assessment election. Legal perfection through collection is an external step and is not proven by this confirmation.',
  electionCode: 'Election reference',
  electionDescription: 'Election evidence',
  result:
    '{{replaced}} future installments replaced and {{transfers}} loss allocations transferred.',
  noJournal: 'The method change preserves past postings and creates no new expense or income.',
  kinds: {
    ASSET_PRICE: 'Asset price',
    UNCONDITIONAL_COMMERCIAL_DISCOUNT: 'Unconditional discount',
    RETURN_OR_CANCELLATION: 'Return or cancellation',
    ACQUISITION_FREIGHT: 'Acquisition freight',
    ACQUISITION_INSURANCE: 'Acquisition insurance',
    INSTALLATION_OR_ASSEMBLY: 'Installation or assembly',
    IPI: 'IPI',
    ACQUISITION_ICMS: 'Acquisition ICMS',
    OTHER_DIRECTLY_ATTRIBUTABLE: 'Other directly attributable cost',
    OTHER_INDIRECT_TAX: 'Other indirect tax',
  },
  states: {
    GROSS_INCLUDES_COMPONENT: 'Gross amount includes this component',
    ALREADY_NET_OF_COMPONENT: 'Amount already net of this component',
  },
  recoverabilityValues: {
    RECOVERABLE: 'Recoverable',
    NON_RECOVERABLE: 'Nonrecoverable',
    NOT_APPLICABLE: 'Not applicable',
  },
  errors: {
    FIXED_ASSET_PIS_COFINS_JURISDICTION_UNSUPPORTED:
      'Fixed-asset PIS/COFINS credits are available only for Brazilian entities. Review the asset entity and fiscal source.',
    FIXED_ASSET_1_48_COMMAND_CONFLICT:
      'This confirmation was already recorded with different evidence. Reload the asset and review the existing election.',
    FIXED_ASSET_1_48_LATER_ALLOWANCE_STATE:
      'A loss review exists after the selected period. Choose a period that preserves the historical sequence.',
    FIXED_ASSET_1_48_SOURCE_EVIDENCE_INVALID:
      'The source has no complete fiscal evidence for this election. Review its document, item and source credits.',

    FIXED_ASSET_1_48_CONVERSION_UNSUPPORTED:
      'This asset does not meet the requirements for a method change. Review its class, source and recorded fiscal election.',
    FIXED_ASSET_1_48_PERIOD_NOT_OPEN: 'The selected accounting period is not open.',
    FIXED_ASSET_1_48_SOURCE_FACE_MISMATCH:
      'The reviewed basis does not reconcile with the source credits. Correct the source first.',
    FIXED_ASSET_FISCAL_BASIS_COMPONENT_EVIDENCE_REQUIRED:
      'A received fiscal document with complete data and a link to the bill line is required. Review the documentary source.',
    FIXED_ASSET_FISCAL_BASIS_COMPONENT_IDENTITY_INVALID:
      'The components do not match the current source. Reload and review them.',
    FIXED_ASSET_FISCAL_BASIS_EXTERNAL_SOURCE_UNSUPPORTED:
      'Costs outside the linked fiscal document are not supported in this workflow yet.',
    FIXED_ASSET_FISCAL_BASIS_REVIEW_IMMUTABLE:
      'This basis is already recorded. A correction requires new evidence while preserving history.',
    FIXED_ASSET_FISCAL_BASIS_REVIEW_REQUIRED:
      'Review the components and provide tax basis evidence.',
    FIXED_ASSET_FISCAL_BASIS_SCOPE_UNSUPPORTED:
      'This workflow supports new domestic machinery or equipment in BRL used directly for noncumulative revenue. Review the classification.',
    FIXED_ASSET_FISCAL_BASIS_SOURCE_LINE_REQUIRED:
      'Link the acquisition to an identified bill line.',
    FIXED_ASSET_PIS_COFINS_RECOVERABILITY_REQUIRED:
      'Record the credit recovery expectation and supporting evidence first.',
    FIXED_ASSET_FISCAL_BASIS_COMPONENT_RELATIONSHIP_INVALID:
      'The declared composition may duplicate an inclusion or exclusion. Review gross and already-net components.',
    FIXED_ASSET_FISCAL_BASIS_OWNER_ALLOCATION_INVALID:
      'The component must be fully assigned to this asset in this workflow. Review its source.',
    FIXED_ASSET_FISCAL_BASIS_SPECIAL_RULE_UNSUPPORTED:
      'The acquisition uses a special treatment not yet supported here.',
    FIXED_ASSET_FISCAL_BASIS_INVALID:
      'The tax basis could not be validated. Review components, document amounts and evidence.',

    FIXED_ASSET_1_48_BASIS_REVIEW_REQUIRED: 'Review the components and provide tax basis evidence.',
    FIXED_ASSET_FISCAL_BASIS_EVIDENCE_REQUIRED:
      'Documentary tax basis evidence is missing. Review the source.',
    FIXED_ASSET_FISCAL_BASIS_COMPONENT_OVERLAP:
      'Components are duplicated or already included in the price. Review the basis.',
    FIXED_ASSET_FISCAL_BASIS_ALLOCATION_UNBALANCED:
      'Amounts assigned to this asset do not reconcile with the source documents.',
    FIXED_ASSET_FISCAL_BASIS_TAX_TREATMENT_REQUIRED:
      'Confirm the tax treatment of acquisition taxes.',
    FIXED_ASSET_FISCAL_BASIS_SOURCE_NOT_CREDITABLE:
      'The source does not satisfy the credit conditions for this method.',
    FIXED_ASSET_FISCAL_BASIS_FACE_MISMATCH:
      'The reviewed tax basis does not reconcile with the source credit. Correct the source first.',
    FIXED_ASSET_IMPORT_BASIS_UNSUPPORTED: 'Import tax basis is not supported in this workflow yet.',
    FIXED_ASSET_1_48_RATE_RULE_UNSUPPORTED:
      'This rate requires a tax treatment not yet supported here.',
    FIXED_ASSET_1_48_PREVIEW_STALE: 'The source or assessment changed. Generate a fresh preview.',
    FIXED_ASSET_1_48_PERIOD_CLOSED: 'The selected accounting period is not open.',
    FIXED_ASSET_1_48_FACE_RECONCILIATION_INVALID:
      'History and future balances do not reconcile with the original credit.',
    FIXED_ASSET_1_48_INSTALLMENT_STATE_INVALID:
      'Pending or incompatible installments prevent this change. Review the tax history.',
    FIXED_ASSET_1_48_ALLOWANCE_TRANSFER_INVALID:
      'The recoverability loss cannot be transferred with the current lineage.',
    FIXED_ASSET_1_48_HISTORICAL_ELECTION_EVIDENCE_REQUIRED:
      'This screen records a new election from the current month. An earlier election requires evidence of the historical act and period corrections, which this workflow does not yet support.',
    FIXED_ASSET_1_48_EFFECTIVE_PERIOD_UNSUPPORTED:
      'A new PIS/COFINS election must start by December 2026. For periods from 2027 onward, review the CBS transition treatment.',
    FIXED_ASSET_1_48_INPUT_INVALID: 'Review the period and election details.',
  },
};
